import Splash from "../components/Splash";
import Login from "../components/Login/Login";
import Verify from "../components/Login/Verify";
import Home from "../components/Home/Home";
import Requests from "../components/Requests/Requests";
import Profile from "../components/Profile/Profile";
import WorkShifts from "../components/Profile/WorkShifts";
import Request from "../components/Requests/Request";
import SelectForRequest from "../components/Drivers/SelectForRequest";
import DriversList from "../components/Drivers/DriversList";
import EditProfile from "../components/Profile/EditProfile";
import DriverProfile from "../components/Drivers/DriverProfile";
import RequestsSmallCargo from "../components/Requests/RequestsSmallCargo";
import DriverRequests from "../components/Drivers/DriverRequests";
import Wallet from "../components/Profile/Wallet";

const appRoutes = [
    {
        id : '0',
        path : '/',
        component : Splash
    },
    {
        id : '1',
        path : '/login',
        component : Login
    },
    {
        id : '2',
        path : '/verify',
        component : Verify
    },
    {
        id : '3',
        path : '/home/:page',
        component : Home
    },
    {
        id : '4',
        path : '/requests',
        component : Requests
    },
    {
        id : '5',
        path : '/profile',
        component : Profile
    },
    {
        id : '6',
        path : '/work-shifts',
        component : WorkShifts
    },

    {
        id : '7',
        path : '/request/:id',
        component : Request
    },
    {
        id : '8',
        path : '/select-driver/:id',
        component : SelectForRequest
    },
    {
        id : '9',
        path : '/drivers',
        component : DriversList
    },
    {
        id : '10',
        path : '/edit-profile',
        component : EditProfile
    },
    {
        id : '11',
        path : '/driver/:id',
        component : DriverProfile
    },
    {
        id : '12',
        path : '/requests-sc',
        component : RequestsSmallCargo
    },
    {
        id : '13',
        path : '/driver-requests/:status/:driver',
        component : DriverRequests
    },

    {
        id : '14',
        path : '/home',
        component : Home
    },
    {
        id : '15',
        path : '/wallet',
        component : Wallet
    },


];
export default appRoutes;